import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
const BasicHeroSection = ({ heading, subheading }) => {
  return (
    <div>
      <div className="text-center">
        <h1 className="text-[2.5rem] text-white font-bold mb-6 break-words">
          {typeof(heading) == 'string' ? parse(heading) : heading}
        </h1>
        {subheading && (<p className="font-semibold text-white text-[1.375rem] leading-[1.875rem] mb-7">
          {typeof(subheading) == 'string' ? parse(subheading) : subheading}
        </p>)}

      </div>
    </div>
  );
};

BasicHeroSection.propTypes = {
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  subheading: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  buttonText: PropTypes.string,
  buttonCustomClasses: PropTypes.string
};

export default BasicHeroSection;